import Avatar from '@orn/shared-web/components/Avatar';
import { ChevronRightIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import { getInitial } from '@orn/shared-web/utils/getInitials';

import Entity from '../../entity';

import type { EntityAvatarFragment } from '../../entity/EntityAvatar/__generated__/EntityAvatar.gql';

const LONG_NAME_THRESHOLD = 35;

interface ISlideoutEntityHeaderProps {
  /** Entity for the avatar (e.g. merchant). Falls back to initials from `name` when null. */
  entity: EntityAvatarFragment | null;
  /** Display name shown below the avatar. */
  name: string;
  /** When provided, the entire section becomes clickable and shows a chevron. */
  onClick?: () => void;
}

const SlideoutEntityHeader = ({ entity, name, onClick }: ISlideoutEntityHeaderProps) => {
  return (
    <div
      className={cx('flex min-w-0 max-w-full flex-col items-center gap-1', !!onClick && 'cursor-pointer')}
      onClick={onClick}
    >
      {entity ? (
        <Entity.Avatar entity={entity} size="3xl" />
      ) : (
        <Avatar contrastBorder={true} size="3xl" initials={getInitial(name)} />
      )}
      <div className="flex min-w-0 max-w-full items-center justify-center gap-1 px-4">
        <div
          className={cx(
            'max-w-full text-center font-semibold text-white',
            name.length > LONG_NAME_THRESHOLD ? 'text-lg' : 'text-xl'
          )}
        >
          {name}
        </div>
        {!!onClick && (
          <div className="bg-utility-brand-825 shrink-0 rounded-full p-0.5">
            <ChevronRightIcon className="size-4 shrink-0 text-white" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SlideoutEntityHeader;
